import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faTruck } from '@fortawesome/pro-light-svg-icons';

export type ProLightTruckProps = IconComponentProps;

export const ProLightTruck = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightTruckProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faTruck}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faTruck}
    />
  );
};

ProLightTruck.displayName = 'ProLightTruck';
